import ClassicExtension from "./ClassicExtension";

const youtubeSelector = "iframe[src*='www.youtube']";

export function initializeYoutubeVideos($root: JQuery): void {
    $root.find(youtubeSelector).each((i, iframe) => {
        const $iframe = $(iframe);
        $iframe.data('aspectRatio', $iframe.height() / $iframe.width())
            .removeAttr('height')
            .removeAttr('width');
    });
    resizeYoutubeVideos($root);
}

function resizeYoutubeVideos($root: JQuery): void {
    $root.find(youtubeSelector).each((i, video) => {
        const $video = $(video);
        const parentWidth = $video.parent().width();
        const maxWidth = $video.data('max-width') ? $video.data('max-width') : 560;
        const width = Math.min(parentWidth, maxWidth);

        $video.width(width).height(width * $video.data('aspectRatio'));
    });
}

/*  Youtube embed videos - resizing */
export default class YoutubeVideosExtension extends ClassicExtension {

    protected init($root): void {
        initializeYoutubeVideos($root);
        $(window).on('resize', () => resizeYoutubeVideos($('body')));
        resizeYoutubeVideos($('body'));
    }

}
